import React, { useEffect, useState } from 'react';
import { ReactComponent as HutricsLogoColor } from 'svg/hutrics-logo-color.svg';
import PropTypes from 'prop-types';

const imageCache = {};

const LogoLoader = ({
  slug,
  fileName = 'login-logo.png',
  className = 'd-block mx-auto',
  containerClassName = '',
  fallbackComponent = <HutricsLogoColor />,
  style = {},
  containerStyle = {},
}) => {
  const [logoSource, setLogoSource] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!slug) {
      setIsLoaded(true);
      return;
    }

    const logoPath = `/client/${slug}/${fileName}`;

    if (imageCache[logoPath]) {
      if (imageCache[logoPath].exists) {
        setLogoSource(logoPath);
      }
      setIsLoaded(true);
      return;
    }

    setIsLoaded(false);
    const img = new Image();

    img.onload = () => {
      imageCache[logoPath] = { exists: true };
      setLogoSource(logoPath);
      setIsLoaded(true);
    };

    img.onerror = () => {
      imageCache[logoPath] = { exists: false };
      setLogoSource(null);
      setIsLoaded(true);
    };

    img.src = logoPath;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [slug, fileName]);

  return (
    <div className={containerClassName} style={containerStyle}>
      {isLoaded &&
        (logoSource ? (
          <img src={logoSource} alt="Company Logo" className={className} style={style} />
        ) : (
          React.cloneElement(fallbackComponent, {
            className: `${fallbackComponent.props.className || ''} ${className}`.trim(),
            style: { ...fallbackComponent.props.style, ...style },
          })
        ))}
    </div>
  );
};

LogoLoader.propTypes = {
  slug: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  fallbackComponent: PropTypes.node,
};

export default LogoLoader;
